export default () => ({
    errors: {},
    get isValid() {
        return !Object.values(this.errors).map((value) => value.length != 0).some(a => a);
    },
    setError: function (field, error) {
        this.errors[field] = error;
    },
})